import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { API_ROUTES } from '../../util/route.constants';
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {

  constructor(private readonly  http:HttpClient) { }
  forgotPassword(email:string): Observable<{success:boolean}>{
    return this.http.post<{success:boolean}>(`${environment.user_management_api_url}${API_ROUTES.FORGOT_PASSWORD}`, {email})
  }
}
